jQuery(document).ready(function($){
	debounce();
	mainAudio();
	menu();
	mainAnimation();
	mainPreview();
	clipText();
	translationLibrary();
	teaser();
	filters();
	
});

function mainAudio() {
	$('.main-audio').click(function() {
		if ($('#main-audio')[0].paused == false) {
			$('#main-audio').trigger("pause");
			$('.main-audio__icons').removeClass('play');
		} else {
			$('#main-audio').trigger("play");
			$('.main-audio__icons').addClass('play');
		}
	});
}

function debounce(func, wait, immediate) {
	let timeout;

	return function executedFunction() {
		const context = this;
		const args = arguments;

		const later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};

		const callNow = immediate && !timeout;

		clearTimeout(timeout);

		timeout = setTimeout(later, wait);

		if (callNow) func.apply(context, args);
	};
};

function menu() {
	$('.burger-btn, .burger-close-btn').click(function(){
		let menuButton = $('.header__menu-btn');
		event.stopPropagation();
		if (!menuButton.hasClass('menu-active')) {
			menuButton.addClass('menu-active');
			$('body,html').animate({scrollTop: 0}, 0);
			$('header').addClass('menu-opened');
			let oldWidth = $(document).width();
			$('body').addClass('menu-opened');
			let newWidth = $(document).width();
			let res = newWidth - oldWidth;
			$('body').css('margin-right',res).css('width', 'calc(100% - '+ res +'px)');
			$('.header-menu-bg').css('width', 'calc(100% + '+ res +'px)');
		} else {
			$('header').removeClass('menu-opened');
			menuButton.removeClass('menu-active');
			setTimeout(function () {
				$('body').css('margin-right', 0).css('width', '100%').removeClass('menu-opened');
				$('.header-menu-bg').css('width', '100%');  
			}, 500);
		}
	});
}

var isAnimation = false;
function _mainAnimation() {
	isAnimation = true;
	var icohover = document.getElementsByClassName("main-animation");
	Array.prototype.forEach.call(icohover, icon => {
		var animation = bodymovin.loadAnimation({
			container:  icon,
			path:       icon.dataset.file + '.json',
			renderer:   'canvas',
			loop:       false,
			autoplay:   false,
		});

		var bpoint = icon.dataset.bpoint;

		icon.addEventListener("mouseenter", function (event) {
			animation.playSegments([0, parseInt(icon.dataset.bpoint)], true);
		});

		icon.addEventListener("mouseleave", function() {
			animation.playSegments([parseInt(icon.dataset.bpoint) + 1, animation.animationData.op], true);
		});
	});
}
function mainAnimation() {
	$(window).on('resize load', function(){
		if (window.innerWidth > 1023 && isAnimation != true) {
			_mainAnimation();
		}
	});
}

function mainPreview() {
	$('.main-chapters-animation').click(function() {
		$('.chapters-preview').removeClass('active');
		$('.chapters-preview--' + ($(this).data('chapter'))).addClass('active');
	});

	$('.chapters-preview__close').click(function(){
		$('.chapters-preview').removeClass('active');
	});
}

function clipText() {
	$(".chapters-preview__text").dotdotdot({
		watch: true
	});
	$(".library-item__content-wrap").dotdotdot({
		watch: true
	});
}

function translationLibrary() {
	var translationTitle = $('.single-library-heading__title--translation');
	if (translationTitle.length) {
		var defaultTitle = $('.single-library-heading__title--default'),
			defaultTitleVal = defaultTitle.html(),
			defaultContent = $('.article-content--default'),
			translationContent = $('.article-content--translation'),
			button = $('.another-lang-btn');
		button.click(function(){
			$(this).toggleClass('active');
			if (button.hasClass('active')) {
				defaultTitle.html(translationTitle.html());
				defaultContent.hide();
				translationContent.show();
			} else {
				defaultTitle.html(defaultTitleVal);
				translationContent.hide();
				defaultContent.show();
			}
		});
	}
}

function teaser() {
	let teaserBg = $('.teaser-bg');
	$('.chapters-heading__teaser-btn').click(function(){
		teaserBg.css('display', 'flex');
	});
	$('.teaser-close').click(function(){
		teaserBg.css('display', 'none');
		var vimeoWrap = $('.teaser-container');
   		vimeoWrap.html(vimeoWrap.html());
	});
}

function filters() {
	$('.filters-block__btn').click(function(){
		$('.filters-block').toggleClass('filters-open');
	});

	$('.filters-item__btn').click(function(){
		let filterItem = $(this).closest('.filters-item');
		if (filterItem.hasClass('list-open')) {
			filterItem.removeClass('list-open')
		} else {
			$('.filters-item').removeClass('list-open');
			filterItem.addClass('list-open');
		}
	});

	$('.filters-search').focus(function() { 
		$('.filters-item').removeClass('list-open');
	});

	$('.filter-list-item').click(function(){
		event.stopPropagation();
		$(this).toggleClass('active');
		getLibraryPosts();
	});

	var librarySearchInput = $('#library-search');
	if (librarySearchInput.length) {
		librarySearchInput.keyup( debounce( function(event) {
			if (event.keyCode != 13) {
		    	getLibraryPosts();
				return false;
			}
		}, 1000));
		librarySearchInput.keydown(function(event) {
			if (event.keyCode == 13) {
				getLibraryPosts();
				return false;
			}
		});
	}

	$('.clear-filters').click(function(){
		history.pushState('','', window.location.href.replace(window.location.search,''));
		$('.filter-list-item').removeClass('active');
		librarySearchInput.val('');
		getLibraryPosts();
	});
}

function _getFilterParams() {
	var filterParam = [];

	filterParam['chapters'] = [];
	$('.filter-list-item_chapter.active').each(function() {
		filterParam['chapters'].push($(this).data('chapter'));
	});

	filterParam['formats'] = [];
	$('.filter-list-item_format.active').each(function() {
		filterParam['formats'].push($(this).data('format'));
	});

	filterParam['countries'] = [];
	$('.filter-list-item_country.active').each(function() {
		filterParam['countries'].push($(this).data('country'));
	});

	filterParam['subthemes'] = [];
	$('.filter-list-item_subtheme.active').each(function() {
		filterParam['subthemes'].push($(this).data('subtheme'));
	});

	filterParam['types-of-contributions'] = [];
	$('.filter-list-item_type.active').each(function() {
		filterParam['types-of-contributions'].push($(this).data('type'));
	});

	let searchParams = $('#library-search').val();
	if (searchParams.length) {
		filterParam['search'] = [];
		filterParam['search'].push(searchParams);
	}

	return filterParam;
}

function getLibraryPosts() {

	var param = '';

	var filterParams = _getFilterParams();

	if (filterParams['chapters'].length > 0) {
		param += '&chapter=' + filterParams['chapters'];
		$('.filters-item__cnt--chapters').html(filterParams['chapters'].length).show();
	} else {
		$('.filters-item__cnt--chapters').hide();
	}
	if (filterParams['formats'].length > 0) {
		param += '&formats=' + filterParams['formats'];
		$('.filters-item__cnt--formats').html(filterParams['formats'].length).show();
	} else {
		$('.filters-item__cnt--formats').hide();
	}
	if (filterParams['countries'].length > 0) {
		param += '&countries=' + filterParams['countries'];
		$('.filters-item__cnt--countries').html(filterParams['countries'].length).show();
	} else {
		$('.filters-item__cnt--countries').hide();
	}
	if (filterParams['subthemes'].length > 0) {
		param += '&subthemes=' + filterParams['subthemes'];
		$('.filters-item__cnt--subthemes').html(filterParams['subthemes'].length).show();
	} else {
		$('.filters-item__cnt--subthemes').hide();
	}
	if (filterParams['types-of-contributions'].length > 0) {
		param += '&types-of-contributions=' + filterParams['types-of-contributions'];
		$('.filters-item__cnt--types').html(filterParams['types-of-contributions'].length).show();
	} else {
		$('.filters-item__cnt--types').hide();
	}

	if (filterParams['search']) {
		param += '&search=' + filterParams['search'];
	}
	
	if (param != '') {
		var parameters = '?'+ param.slice(1);
	} else {
		var parameters = '';
	}

	history.pushState('','', window.location.origin + '/library/' + parameters);

	var data = {
		'action'                    : 'get_library_posts',
		'chapters'                  : filterParams['chapters'],
		'formats'                   : filterParams['formats'],
		'countries'                 : filterParams['countries'],
		'subthemes'                 : filterParams['subthemes'],
		'types-of-contributions'    : filterParams['types-of-contributions'],
		'search'    				: filterParams['search'],
		'filters'                   : parameters
	};

	$.ajax({
		url:ajaxurl,
		data:data,
		type:'POST',
		success:function(data){
			let res = JSON.parse(data);
			if (res.posts !== ''){
				$('.library-list').html(res.posts);
				clipText();
			}
			$('.pagination').html(res.pagination);
		}
	});
};